import {
  PIICategoryParameterFormats,
  PIICategoryParameterFormatsMetadataArgs,
  getPIICategoryParameterFormatsListMetadata,
} from '../../assets/ts/data/pii/pii-category-parameter-formats'
import useServerData from '../use-server-data'

function usePIICategoryParameterFormatsMetadata(
  fetchArgs,
  waitOnParentDependency = false
) {
  const {
    data: piiCategoryParameterFormatsMetadata,
    error: piiCategoryParameterFormatsMetadataError,
    fetchData: fetchPiiCategoryParameterFormatsMetadata,
    isLoading: piiCategoryParameterFormatsMetadataIsLoading,
  } = useServerData<
    PIICategoryParameterFormats,
    PIICategoryParameterFormatsMetadataArgs
  >(
    getPIICategoryParameterFormatsListMetadata,
    fetchArgs,
    waitOnParentDependency
  )

  return {
    fetchPiiCategoryParameterFormatsMetadata,
    piiCategoryParameterFormatsMetadata,
    piiCategoryParameterFormatsMetadataError,
    piiCategoryParameterFormatsMetadataIsLoading,
  }
}

export default usePIICategoryParameterFormatsMetadata
